module.exports = __webpack_public_path__ + "img/0445_15.2fd3cebb.jpg";